// Event bindings globaux (click/input) + nav boutons P1/P2/P3.

import { S } from './state.js';
import { $, $$, clearE } from './dom.js';
import { setLang, gp, nx1, nx2, nx3, nx3_describe, nx4_triage } from './panels.js';
import {
	renderDropdown, showDropdown, hideDropdown,
	addModel, addQuickPick, changeModelQty, removeModel, selSizeRow,
} from './models.js';
import { pickDay, toggleSurcharge, shiftCalendar } from './calendar.js';
import { verifyEmailMX } from './email.js';
import { bindPhoneVerify } from './phone-verify.js';

export function bind() {
	$$( '[data-ps-lang]' ).forEach( function ( b ) {
		b.addEventListener( 'click', function () { setLang( b.getAttribute( 'data-ps-lang' ) ); } );
	} );

	[ 'f-fname:inFname', 'f-lname:inLname', 'f-title:inTitle', 'f-tel:inTel', 'f-co:inCo', 'f-factory-address:inFactoryAddress' ]
		.forEach( function ( pair ) {
			var f = pair.split( ':' )[ 0 ], i = pair.split( ':' )[ 1 ];
			var inp = $( i );
			if ( inp ) inp.addEventListener( 'input', function () { clearE( f ); } );
		} );

	var inEmail = $( 'inEmail' );
	if ( inEmail ) {
		inEmail.addEventListener( 'input', function () {
			clearE( 'f-email' );
			S.emailVerified = false;
			[ 'emailMXStatus', 'emailMXMsg' ].forEach( function ( id ) {
				var el = $( id ); if ( el ) el.style.display = 'none';
			} );
		} );
		inEmail.addEventListener( 'blur', function () { verifyEmailMX( inEmail.value.trim() ); } );
	}

	var ms = $( 'modelSearch' );
	if ( ms ) {
		var isSrd = !! document.querySelector( '.probot-soum.is-srd' );
		// Direction A keeps the catalog permanently visible: only re-render
		// on input (filter), no focus/blur popup behaviour. Old design uses
		// the dropdown popup pattern on focus/blur.
		ms.addEventListener( 'input', function () {
			renderDropdown();
			if ( ! isSrd ) showDropdown();
		} );
		if ( ! isSrd ) {
			ms.addEventListener( 'focus', function () { showDropdown(); } );
			ms.addEventListener( 'blur',  function () { setTimeout( hideDropdown, 200 ); } );
		}
	}

	document.addEventListener( 'click', function ( e ) {
		var t = e.target;
		var addBtn = t.closest && t.closest( '[data-ps-add]' );
		if ( addBtn ) { e.preventDefault(); addModel( addBtn.getAttribute( 'data-ps-add' ) ); return; }

		var qp = t.closest && t.closest( '[data-ps-qpick]' );
		if ( qp ) { e.preventDefault(); addQuickPick( qp.getAttribute( 'data-ps-qpick' ) ); return; }

		var qtyBtn = t.closest && t.closest( '[data-ps-model-qty]' );
		if ( qtyBtn ) {
			e.preventDefault();
			changeModelQty( qtyBtn.getAttribute( 'data-ps-model-qty' ), parseInt( qtyBtn.getAttribute( 'data-ps-delta' ), 10 ) );
			return;
		}

		var del = t.closest && t.closest( '[data-ps-model-del]' );
		if ( del ) { e.preventDefault(); removeModel( del.getAttribute( 'data-ps-model-del' ) ); return; }

		var sz = t.closest && t.closest( '[data-ps-size]' );
		if ( sz ) {
			e.preventDefault();
			selSizeRow( sz.getAttribute( 'data-ps-size-row' ), sz.getAttribute( 'data-ps-size' ) );
			return;
		}

		// P3 — calendrier
		var pd = t.closest && t.closest( '[data-ps-pickday]' );
		if ( pd ) {
			e.preventDefault();
			var parts = pd.getAttribute( 'data-ps-pickday' ).split( '-' );
			pickDay( parseInt( parts[0], 10 ), parseInt( parts[1], 10 ), parseInt( parts[2], 10 ) );
			return;
		}

		// P3 — surcharges
		var su = t.closest && t.closest( '[data-ps-sur]' );
		if ( su ) {
			e.preventDefault();
			toggleSurcharge( su.getAttribute( 'data-ps-sur' ) );
			return;
		}
	} );

	document.addEventListener( 'input', function ( e ) {
		var t = e.target;
		if ( t.matches && t.matches( '[data-ps-other-row]' ) ) {
			S.otherText[ t.getAttribute( 'data-ps-other-row' ) ] = t.value;
		}
	} );

	var calPrev = $( 'qcalPrev' ); if ( calPrev ) calPrev.addEventListener( 'click', function () { shiftCalendar( -2 ); } );
	var calNext = $( 'qcalNext' ); if ( calNext ) calNext.addEventListener( 'click', function () { shiftCalendar( 2 ); } );

	// Forward navigation buttons. The handler each btnNx{i} calls depends on
	// the active flow:
	//   • Maintenance (4 steps): nx1 → nx2 → nx3 (final submit).
	//   • Service     (6 steps): nx1 → nx2 → nx3_describe → nx4_triage → nx3 (final submit, on btnNx5).
	var b1 = $( 'btnNx1' ); if ( b1 ) b1.addEventListener( 'click', nx1 );
	var b2 = $( 'btnNx2' ); if ( b2 ) b2.addEventListener( 'click', nx2 );

	var b3 = $( 'btnNx3' );
	if ( b3 ) {
		b3.addEventListener( 'click', S.quoteType === 'service' ? nx3_describe : nx3 );
	}
	var b4 = $( 'btnNx4' ); if ( b4 ) b4.addEventListener( 'click', nx4_triage );
	var b5 = $( 'btnNx5' ); if ( b5 ) b5.addEventListener( 'click', nx3 );

	// Back buttons walk one step back. Same behaviour for both flows.
	[ 'btnBk2', 'btnBk3', 'btnBk4', 'btnBk5' ].forEach( function ( id, idx ) {
		var btn = $( id );
		if ( btn ) btn.addEventListener( 'click', function () { gp( idx + 1 ); } );
	} );

	// v1.0.95 — Phone verification flow (Twilio Verify SMS OTP)
	bindPhoneVerify();

	// v1.0.97 — Clear T&C consent error when user toggles the checkbox
	var psConsentTerms = $( 'psConsentTerms' );
	if ( psConsentTerms ) {
		psConsentTerms.addEventListener( 'change', function () {
			var err = $( 'psConsentTermsErr' );
			if ( err && psConsentTerms.checked ) err.style.display = 'none';
		} );
	}
}
